class PriorityModel
{
    constructor(obj?: PriorityModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: number | null;
    public Level?: string | null;
    public Status?: string | null;
    public Impact?: string | null;
    public IssueDescription?: string | null;
    public RecCount?: number | null;
}

export { PriorityModel }
